export default "__VITE_ASSET__BYu1zBS2__"